export const LANGUAGE_LABELS = {
  de: 'German',
  en: 'English',
  es: 'Spanish',
  nl: 'Dutch',
  ru: 'Russian',
  it: 'Italian',
  fr: 'French',
  tr: 'Turkish',
  pl: 'Polish',
};
